import './global-types.js';
import './schema-builder.js';
import SchemaBuilder, { BasePlugin } from '@pothos/core';
export * from './types.js';
const pluginName = "withInput";
export default pluginName;
export class PothosWithInputPlugin extends BasePlugin {
}
SchemaBuilder.registerPlugin(pluginName, PothosWithInputPlugin);
//# sourceMappingURL=index.js.map
